import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Music = () => {
  const [playingTrack, setPlayingTrack] = useState(null);
  const [activeAlbum, setActiveAlbum] = useState(null);
  const { t } = useTranslation();

  // Icônes SVG inline professionnelles
  const Icons = {
    Play: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M8 5v14l11-7z"/>
      </svg>
    ),
    Pause: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
      </svg>
    ),
    Spotify: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
    YouTube: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
      </svg>
    ),
    TikTok: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
      </svg>
    ),
    Amazon: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.27 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 0 0 0 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 0 0 0-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.435 13.534a2.918 2.918 0 0 1 0-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.645 9.565 5.811a2.918 2.918 0 0 1 0 3.068zM12 7a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"/>
      </svg>
    ),
    Music: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
      </svg>
    ),
    Headphones: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"/>
      </svg>
    ),
    Star: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
      </svg>
    ),
    Heart: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    ),
    Download: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
    ),
    Share: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
      </svg>
    )
  };

  // Albums
  // Albums en français (version statique fixe)
const albums = [
  {
    id: 1,
    title: "Intimité avec Jésus",
    description: "Un projet profond né d'une visitation divine. Cet album marque le début du ministère musical avec des chants d'adoration intimes et transformateurs.",
    year: "2021",
    tracks: [
      { name: "Intimité", duration: "4:32" },
      { name: "Sur ce rocher", duration: "3:58" },
      { name: "Je m'abandonne", duration: "5:12" },
      { name: "Jusqu'au bout", duration: "4:45" },
      { name: "Nakutegemeya ", duration: "4:23" },
      { name: "Seul à Seul", duration: "4:47" },
      { name: "Sikiya kilio changu ", duration: "5:12" },
      { name: "Je vois le Soleil", duration: "4:15" },
      { name: "Le mien", duration: "5:08" }
    ],
    streams: "500K+",
    coverColor: "from-blue-600/20 to-purple-600/20"
  },
  {
    id: 2,
    title: "Les Algues sur ma Rive",
    description: "Un voyage spirituel illustrant le combat, la purification et la restauration. Des mélodies poétiques qui accompagnent la marche avec Dieu.",
    year: "2023",
    tracks: [
      { name: "Les Algues sur ma Rive", duration: "5:24" },
      { name: "Nikufanane Yesu ", duration: "4:18" },
      { name: "I Surrender All to You ", duration: "4:52" },
      { name: "Figure toi ", duration: "5:36" },
      { name: "Le monde à l'envers", duration: "4:36" },
      { name: "Moyo usiliye", duration: "4:16" },
      { name: "Digne", duration: "5:12" },
      { name: "Je vais T'adorer", duration: "4:25" }
    ],
    streams: "750K+",
    coverColor: "from-green-600/20 to-emerald-600/20"
  },
  {
    id: 3,
    title: "Évidence",
    description: "Une déclaration musicale que la bonté de Dieu est une Évidence. Compilation enrichie de nouveaux cantiques de louange et d'adoration.",
    year: "2025",
    tracks: [
      { name: "Évidence", duration: "4:38" },
      { name: "Mshindi ", duration: "4:15" },
      { name: "Lokola ndeke ", duration: "5:22" },
      { name: "Jésus est Roi", duration: "4:22" },
      { name: "Calvaire", duration: "4:35" },
      { name: "Tambwe ", duration: "5:18" },
      { name: "Atta El Roy ", duration: "4:50" }
    ],
    streams: "1M+",
    coverColor: "from-orange-600/20 to-red-600/20"
  }
];

  // Plateformes avec liens réels
  const platforms = [
    { 
      name: 'Spotify', 
      icon: <Icons.Spotify />, 
      url: 'https://open.spotify.com/intl-fr/artist/3Wi2QtUBfyY54IdnbNzoT2',
      color: 'hover:text-green-500',
      stats: t('music.platforms.spotify.stats')
    },
    { 
      name: 'Vevo', 
      icon: <Icons.YouTube />, 
      url: 'https://youtube.com/@esaiewiondjavevo?si=lOZYm_b4K759NAKX',
      color: 'hover:text-green-500',
      stats: t('music.platforms.vevo.stats')
    },
    { 
      name: 'YouTube', 
      icon: <Icons.YouTube />, 
      url: 'https://youtube.com/@esaie_wilondja?si=5H8lXfmnzGZjCKhk',
      color: 'hover:text-red-500',
      stats: t('music.platforms.youtube.stats')
    },
    
    { 
      name: 'Amazon Music', 
      icon: <Icons.Amazon />, 
      url: 'https://www.amazon.fr/music/player/artists/B0FGRXL9V8/esaie-wilondja',
      color: 'hover:text-orange-500',
      stats: t('music.platforms.amazon.stats')
    }
  ];

  // Statistiques globales
  const globalStats = [
    { number: '3', label: t('music.stats.albums'), icon: <Icons.Music /> },
    { number: '60+', label: t('music.stats.songs'), icon: <Icons.Star /> },
    { number: '2M+', label: t('music.stats.streams'), icon: <Icons.Headphones /> },
    { number: '10+', label: t('music.stats.countries'), icon: <Icons.Heart /> }
  ];

  // Citations inspirantes
  const quotes = [
    {
      text: t('music.quotes.quote1.text'),
      author: t('music.quotes.quote1.author')
    },
    {
      text: t('music.quotes.quote2.text'),
      author: t('music.quotes.quote2.author')
    }
  ];

  const handleVideoClick = (videoId) => {
    const videoUrl = `https://youtu.be/${videoId}`
    window.open(videoUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black z-10"></div>
        <div 
          className="absolute inset-0 z-0 opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        <div className="container mx-auto px-4 relative z-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <div className="inline-flex items-center gap-3 mb-6">
              <Icons.Music className="w-10 h-10 text-yellow-600" />
              <h1 className="text-5xl md:text-7xl font-bold font-serif">
                {t('music.title')} <span className="text-yellow-600">{t('music.titleHighlight')}</span>
              </h1>
            </div>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto">
              {t('music.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Statistiques Globales */}
      <section className="py-16 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {globalStats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                className="text-center p-6 bg-gray-900/30 rounded-2xl backdrop-blur-sm border border-gray-800"
              >
                <motion.div 
                  className="text-yellow-500 mb-4 inline-block"
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.6 }}
                >
                  {stat.icon}
                </motion.div>
                <div className="text-3xl font-bold text-white mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-400 text-sm font-medium">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Albums Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <div className="max-w-5xl mx-auto mb-20 px-4">
              <div className="flex flex-col md:grid md:grid-cols-2 items-center justify-center gap-8 md:gap-10">
                {/* Photo 1 */}
                <div className="relative w-full max-w-md md:max-w-none ml-8">
                  <div className="relative aspect-[1/1.618] max-h-[600px] rounded-2xl overflow-hidden shadow-2xl">
                    <img 
                      src="/assets/images/profil.jpeg"
                      alt={t('music.photos.photo1.alt')}
                      className="absolute inset-0 w-full h-full object-cover object-center hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute -inset-[2px] border-3 border-yellow-500/30 rounded-2xl pointer-events-none"></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                </div>
                
                {/* Photo 2 */}
                <div className="relative w-full max-w-md md:max-w-none ml-8">
                  <div className="relative aspect-[1/1.618] max-h-[600px] rounded-2xl overflow-hidden shadow-2xl">
                    <img 
                      src="/assets/images/profill.JPG"
                      alt={t('music.photos.photo2.alt')}
                      className="absolute inset-0 w-full h-full object-cover object-center hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute -inset-[2px] border-3 border-yellow-500/30 rounded-2xl pointer-events-none"></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                </div>
              </div>
            </div>
            <h2 className="text-4xl font-bold mb-4">
              {t('music.albumsSection.title')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('music.albumsSection.subtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {albums.map((album, index) => (
              <motion.div
                key={album.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
                whileHover={{ y: -10 }}
                className="group cursor-pointer"
                onClick={() => setActiveAlbum(activeAlbum === album.id ? null : album.id)}
              >
                <div className="bg-gradient-to-b from-gray-900 to-black rounded-3xl overflow-hidden border border-gray-800 hover:border-yellow-500/30 transition-all duration-500 shadow-2xl">
                  {/* Album Header */}
                  <div className={`relative h-48 ${album.coverColor} p-6`}>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <Icons.Music className="w-24 h-24 text-white/20" />
                    </div>
                    <div className="relative z-10 flex justify-between items-start">
                      <div>
                        <div className="inline-block px-4 py-1 bg-black/50 rounded-full text-sm text-white mb-3">
                          {album.year}
                        </div>
                        <h3 className="text-2xl font-bold text-white">{album.title}</h3>
                      </div>
                      <div className="text-right">
                        <div className="text-yellow-600 text-sm font-semibold">{album.streams}</div>
                        <div className="text-gray-400 text-xs">{t('music.streams')}</div>
                      </div>
                    </div>
                  </div>

                  {/* Album Content */}
                  <div className="p-6">
                    <p className="text-gray-400 mb-6 leading-relaxed">
                      {album.description}
                    </p>

                    {/* Tracklist */}
                    <div className="space-y-3 mb-6">
                      <h4 className="font-semibold text-white mb-3 flex items-center">
                        <Icons.Headphones className="w-5 h-5 text-yellow-600 mr-2" />
                        {t('music.tracks')} ({album.tracks.length})
                      </h4>
                      {album.tracks.map((track, trackIndex) => (
                        <div
                          key={trackIndex}
                          className={`flex items-center justify-between p-3 rounded-xl transition-all duration-300 ${
                            playingTrack === `${album.id}-${trackIndex}`
                              ? 'bg-yellow-500/10 border border-yellow-500/30'
                              : 'bg-gray-900/50 hover:bg-gray-800/50'
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setPlayingTrack(playingTrack === `${album.id}-${trackIndex}` ? null : `${album.id}-${trackIndex}`);
                          }}
                        >
                          <div className="flex items-center space-x-3">
                            <button className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                              playingTrack === `${album.id}-${trackIndex}`
                                ? 'bg-yellow-500 text-black'
                                : 'bg-gray-800 text-gray-300 hover:bg-yellow-600 hover:text-black'
                            }`}>
                              {playingTrack === `${album.id}-${trackIndex}` ? <Icons.Pause /> : <Icons.Play />}
                            </button>
                            <span className="text-gray-300">{track.name}</span>
                          </div>
                          <span className="text-gray-500 text-sm">{track.duration}</span>
                        </div>
                      ))}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex space-x-3">
                      <a
                        href={platforms[0].url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-3 rounded-xl font-semibold text-center hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300"
                      >
                        {t('music.listenOnSpotify')}
                      </a>
                      <button className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-800 border border-gray-700 hover:bg-gray-700 hover:border-yellow-500/30 transition-all duration-300">
                        <Icons.Heart className="w-5 h-5 text-gray-300" />
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Plateformes de Streaming */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('music.platforms.title')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('music.platforms.subtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {platforms.map((platform, index) => (
              <motion.a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05, y: -5 }}
                className="group"
              >
                <div className="bg-gradient-to-b from-gray-900/50 to-black/50 rounded-2xl p-6 border border-gray-800 hover:border-gray-700 transition-all duration-500 h-full">
                  <div className="flex flex-col items-center text-center h-full">
                    <div className={`w-16 h-16 rounded-2xl bg-gray-900 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 ${platform.color}`}>
                      {platform.icon}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">
                      {platform.name}
                    </h3>
                    <p className="text-gray-400 text-sm mb-4">
                      {platform.stats}
                    </p>
                    <div className="mt-auto pt-4 border-t border-gray-800 w-full">
                      <span className="text-yellow-600 text-sm font-medium group-hover:underline">
                        {t('music.listenNow')} →
                      </span>
                    </div>
                  </div>
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </section>

      {/* Citations Inspirantes */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {quotes.map((quote, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="bg-gradient-to-br from-gray-900/50 to-black/50 rounded-3xl p-8 border border-gray-800"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-yellow-600 to-yellow-800 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icons.Music className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="text-gray-300 text-lg leading-relaxed italic mb-4">
                      "{quote.text}"
                    </p>
                    <p className="text-yellow-600 font-semibold">
                      — {quote.author}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto"
          >
            <div className="bg-gradient-to-br from-gray-900/50 to-black/50 rounded-3xl p-12 border border-gray-800">
              <Icons.Headphones className="w-16 h-16 text-yellow-600 mx-auto mb-6" />
              
              <h2 className="text-4xl font-bold text-white mb-6">
                {t('music.cta.title')}
              </h2>
              
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                {t('music.cta.description')}
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a
                  href="https://youtube.com/@esaie_wilondja?si=5H8lXfmnzGZjCKhk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-xl font-semibold hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300"
                >
                  {t('music.cta.subscribeYoutube')}
                </a>
                
                <a
                  href="https://open.spotify.com/intl-fr/artist/3Wi2QtUBfyY54IdnbNzoT2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 border-2 border-gray-700 text-gray-300 rounded-xl font-semibold hover:bg-gray-800 hover:text-white transition-all duration-300"
                >
                  {t('music.cta.followSpotify')}
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Music;